const languages = [
  {
    code : "ko",
    initial : "KOR",
    lang_ENG : "Korean",
    lang_KOR : "한국어",
    name_ENG : "Republic of Korea",
    name_KOR : "대한민국",
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "us",
    initial : "USA",
    lang_ENG : "English",
    lang_KOR : "영어",
    name_ENG : "United States of America",
    name_KOR : "미국",
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "jp",
    initial : "JPN",
    lang_ENG : "Japanese",
    lang_KOR : "일본어",
    name_ENG : "Japan",
    name_KOR : "일본",
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "zh-cht",
    initial : "CHN",
    lang_ENG : "Traditional Chinese",
    lang_KOR : "중국어(번체)",
    name_ENG : "China",
    name_KOR : "중국",
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "zh-chs",
    initial : "CHN",
    lang_ENG : "Simplified chinese",
    lang_KOR : "중국어(간체)",
    name_ENG : "China",
    name_KOR : "중국",
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "ru",
    initial : "RUS",
    lang_ENG : "Russian",
    lang_KOR : "러시아어",
    name_ENG : "Russia",
    name_KOR : "러시아",
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "es",
    initial : "ESP",
    lang_ENG : "Spanish",
    lang_KOR : "스페인어",
    name_ENG : "Spain",
    name_KOR : "스페인",
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "hi",
    initial : "",
    lang_ENG : "Hindi",
    lang_KOR : "힌디어",
    name_ENG : ["Republic of India", "Republic of Fiji"],
    name_KOR : ["인도", "피지"],
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "ar",
    initial : "",
    lang_ENG : "Arabic",
    lang_KOR : "아랍어",
    name_ENG : [],
    name_KOR : [],
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "pt",
    initial : "",
    lang_ENG : "Portuguese",
    lang_KOR : "포르투갈어",
    name_ENG : [],
    name_KOR : [],
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "bn",
    initial : "",
    lang_ENG : "Bengali",
    lang_KOR : "벵골어",
    name_ENG : [],
    name_KOR : [],
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "pa",
    initial : "",
    lang_ENG : "Punjabi",
    lang_KOR : "펀자브어",
    name_ENG : [],
    name_KOR : [],
    // background_color : "blue",
    // color : "white",
  },
  {
    code : "de",
    initial : "",
    lang_ENG : "German language",
    lang_KOR : "독일어",
    name_ENG : [],
    name_KOR : [],
    // background_color : "blue",
    // color : "white",
  },
]

export const getLanguages = () => (languages);

export const findLanguage = (langCode) => (languages.find( lang => (lang.code === langCode)));